import { HeroId } from "@rivalwatch/shared";
import type { ClientHero, FxView, HeroFx, ProjectileFrame, ZoneFrame } from "./types.ts";
import type { Scene } from "@babylonjs/core";
import h0 from "./captain-americano/index.ts";
import h1 from "./doctor-estranged/index.ts";
import h2 from "./root/index.ts";
import h3 from "./the-bulk/index.ts";
import h4 from "./magnetron/index.ts";
import h5 from "./penny-parka/index.ts";
import h6 from "./thud/index.ts";
import h7 from "./venison/index.ts";
import h8 from "./black-panthera/index.ts";
import h9 from "./black-window/index.ts";
import h10 from "./squawkeye/index.ts";
import h11 from "./hella/index.ts";
import h12 from "./irony-fist/index.ts";
import h13 from "./ion-man/index.ts";
import h14 from "./tragik/index.ts";
import h15 from "./noon-knight/index.ts";
import h16 from "./sub-marinara/index.ts";
import h17 from "./psyclone/index.ts";
import h18 from "./scarlet-twitch/index.ts";
import h19 from "./cider-man/index.ts";
import h20 from "./squirrely-girl/index.ts";
import h21 from "./star-lorde/index.ts";
import h22 from "./brainstorm/index.ts";
import h23 from "./the-punnisher/index.ts";
import h24 from "./winter-shoulder/index.ts";
import h25 from "./woolverine/index.ts";
import h26 from "./atom-warlock/index.ts";
import h27 from "./cloak-and-swagger/index.ts";
import h28 from "./geoff/index.ts";
import h29 from "./lowkey/index.ts";
import h30 from "./luna-snowcone/index.ts";
import h31 from "./mantissa/index.ts";
import h32 from "./pocket-raccoon/index.ts";

export const CLIENT_HEROES: Record<HeroId, ClientHero> = {
  [HeroId.CaptainAmericano]: h0,
  [HeroId.DoctorEstranged]: h1,
  [HeroId.Root]: h2,
  [HeroId.Bulk]: h3,
  [HeroId.Magnetron]: h4,
  [HeroId.PennyParka]: h5,
  [HeroId.Thud]: h6,
  [HeroId.Venison]: h7,
  [HeroId.BlackPanthera]: h8,
  [HeroId.BlackWindow]: h9,
  [HeroId.Squawkeye]: h10,
  [HeroId.Hella]: h11,
  [HeroId.IronyFist]: h12,
  [HeroId.IonMan]: h13,
  [HeroId.Tragik]: h14,
  [HeroId.NoonKnight]: h15,
  [HeroId.SubMarinara]: h16,
  [HeroId.Psyclone]: h17,
  [HeroId.ScarletTwitch]: h18,
  [HeroId.CiderMan]: h19,
  [HeroId.SquirrelyGirl]: h20,
  [HeroId.StarLorde]: h21,
  [HeroId.Brainstorm]: h22,
  [HeroId.Punnisher]: h23,
  [HeroId.WinterShoulder]: h24,
  [HeroId.Woolverine]: h25,
  [HeroId.AtomWarlock]: h26,
  [HeroId.CloakSwagger]: h27,
  [HeroId.Geoff]: h28,
  [HeroId.Lowkey]: h29,
  [HeroId.LunaSnowcone]: h30,
  [HeroId.Mantissa]: h31,
  [HeroId.PocketRaccoon]: h32,
};
export type { ClientHero, GearCtx, HeroAudio } from "./types.ts";

const merged = <T>(pick: (h: ClientHero) => Record<number, T> | undefined) => Object.assign({}, ...Object.values(CLIENT_HEROES).map((h) => pick(h) ?? {})) as Record<number, T>;
/** Kind → hero-built view/effect. Kind ids are unique across heroes (per-hero ranges). */
export const PROJECTILE_VIEWS = merged<(scene: Scene, f: ProjectileFrame) => FxView<unknown, ProjectileFrame>>((h) => h.projectiles);
export const ZONE_VIEWS = merged<(scene: Scene, f: ZoneFrame) => FxView<unknown, ZoneFrame>>((h) => h.zones);
export const HERO_FX = merged<HeroFx>((h) => h.fx);
